import { TaiLieu } from "./TaiLieu";

export class ChungChi {
    "id": number;
    "idNhanVien": number;
    "tenChungChi": string;
    "loaiChungChi": string;
    "donViCap": string;
    "ngayCapChungChi": Date;
    "xepLoai":string;
    "apDungTuNgay": Date;
    "apDungDenNgay": Date | null;
    "idQuaTrinhDaoTao": number | null;
    "dsTaiLieu": Array<TaiLieu>;
}
